import { diasUteis } from "../calculos";
import { F } from "../gerencialFields";
import { startOfDay, toDate } from "../status";

export const ZONAS_PULMAO_DEFAULT = Object.freeze({
  verde: 0.33,
  amarelo: 0.67,
  vermelho: 1.0,
});

export const ZONA_LABELS = Object.freeze({
  verde: "Verde",
  amarelo: "Amarelo",
  vermelho: "Vermelho",
  preto: "Preto",
});

function deadlineDoAmbiente(amb) {
  return (
    toDate(amb?.[F.DATA_REPROGRAMADA]) ||
    toDate(amb?.[F.ENTREGA_PREVISTA])
  );
}

export function statusPulmao(amb, hoje = new Date(), zonas = ZONAS_PULMAO_DEFAULT) {
  const today = startOfDay(hoje);
  const aprovacao = toDate(amb?.[F.APROVACAO_DO_EXECUTIVO]);
  const entrega = deadlineDoAmbiente(amb);

  if (!today || !aprovacao || !entrega) {
    return {
      zona: null,
      pctConsumido: null,
      pulmaoTotal: null,
      consumido: null,
    };
  }

  const total = diasUteis(aprovacao, entrega);
  const consumidoRaw = diasUteis(aprovacao, today);
  const consumido = consumidoRaw == null ? 0 : Math.max(0, consumidoRaw);

  if (total == null || total <= 0) {
    return { zona: "preto", pctConsumido: 1, pulmaoTotal: total, consumido };
  }

  const pct = consumido / total;
  let zona;
  if (pct >= 1) zona = "preto";
  else if (pct >= zonas.amarelo) zona = "vermelho";
  else if (pct >= zonas.verde) zona = "amarelo";
  else zona = "verde";

  return { zona, pctConsumido: pct, pulmaoTotal: total, consumido };
}

export function contarPorZona(ambientes, hoje, zonas) {
  const counts = { verde: 0, amarelo: 0, vermelho: 0, preto: 0, semDado: 0 };
  const lista = Array.isArray(ambientes) ? ambientes : [];
  for (const amb of lista) {
    const { zona } = statusPulmao(amb, hoje, zonas);
    if (zona) counts[zona]++;
    else counts.semDado++;
  }
  return counts;
}

export function ambientesCriticos(
  ambientes,
  { limite = 10, hoje, zonas } = {}
) {
  const lista = Array.isArray(ambientes) ? ambientes : [];
  const enriquecidos = lista
    .map((amb) => ({ amb, status: statusPulmao(amb, hoje, zonas) }))
    .filter(({ status }) => status.zona && status.zona !== "verde");

  const ordemZona = { preto: 0, vermelho: 1, amarelo: 2 };
  enriquecidos.sort((left, right) => {
    const ordemL = ordemZona[left.status.zona] ?? 99;
    const ordemR = ordemZona[right.status.zona] ?? 99;
    if (ordemL !== ordemR) return ordemL - ordemR;
    return (right.status.pctConsumido ?? 0) - (left.status.pctConsumido ?? 0);
  });

  return enriquecidos.slice(0, limite);
}

export { deadlineDoAmbiente };

function zonaParaPct(pct, zonas) {
  if (pct == null) return null;
  if (pct >= 1) return "preto";
  if (pct >= zonas.amarelo) return "vermelho";
  if (pct >= zonas.verde) return "amarelo";
  return "verde";
}

export function histogramaConsumo(
  ambientes,
  { hoje = new Date(), zonas = ZONAS_PULMAO_DEFAULT, bins = 10 } = {}
) {
  const tamanho = Math.max(2, Math.floor(bins));
  const buckets = Array.from({ length: tamanho }, (_, index) => {
    const inicio = index / tamanho;
    const fim = (index + 1) / tamanho;
    const meio = (inicio + fim) / 2;
    return {
      inicio,
      fim,
      label: `${Math.round(inicio * 100)}–${Math.round(fim * 100)}%`,
      zona: zonaParaPct(meio, zonas) || "verde",
      count: 0,
    };
  });
  const overflow = { label: "100%+", zona: "preto", count: 0 };
  const lista = Array.isArray(ambientes) ? ambientes : [];

  for (const amb of lista) {
    const { pctConsumido } = statusPulmao(amb, hoje, zonas);
    if (pctConsumido == null) continue;
    if (pctConsumido >= 1) {
      overflow.count++;
      continue;
    }
    const indice = Math.min(
      tamanho - 1,
      Math.floor(pctConsumido * tamanho)
    );
    buckets[indice].count++;
  }

  return [...buckets, overflow];
}
